import React from "react";
import {FieldsetAdapter} from "./FieldsetAdapter";
import type {FieldsetAdapterProps} from "./FieldsetAdapter";
import {inputType} from "./inputConstants";
import {createFakeEvent} from "./inputUtility";

export const RadioList: React.FC<FieldsetAdapterProps> = (props) => {

    const {onChange, value=""} = props;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = event.target;

        return onChange?.(createFakeEvent(value, name));
    };
    return <FieldsetAdapter {...props} onChange={handleChange} inputType={inputType.RADIO} value={value.toString()}/>;
};
